export class DefaultRoutes {
    static questions = "questions"
    static skills = "skills"
    static topics = "topics"
    static login = "signin"
    static user = "user"
    static error404 = "error/404"
    static error500 = "error/500"
}

export class QuestionsRoutes {
    static files = DefaultRoutes.questions + "/files"
    static fullRender = DefaultRoutes.questions + "/full-render"
    static edit = DefaultRoutes.questions + "/edit/:id"
    static view = DefaultRoutes.questions + "/view/:id"
    static create = DefaultRoutes.questions + "/create"
}

export class SkillsRoutes {
    static files = DefaultRoutes.skills + "/files"
}

export class TopicsRoutes {
    static files = DefaultRoutes.topics + "/files"
}